import { Component, Input, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { BaseControl } from '../base/base-control';

@Component({
    selector: 'app-date-picker',
    standalone: true,
    templateUrl: './date-picker.component.html',
    styleUrl: './date-picker.component.scss',
    imports: [
        MatFormFieldModule,
        MatDatepickerModule,
        MatInputModule,
        MatNativeDateModule
    ],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DatePickerComponent),
            multi: true
        }]
})
export class DatePickerComponent extends BaseControl<Date> {

  @Input() min?: Date;
  @Input() max?: Date;
}
